const eclipseItems = (items, itemsToShow = 2) => {
  const itemsLength = items.length;

  if (!itemsToShow) {
    return '';
  }

  if (itemsLength < 2) {
    return `${items[0]}`;
  }

  if (itemsLength < itemsToShow + 1) {
    return `${items.slice(0, -1).join(', ')} and ${items[itemsLength - 1]}`;
  }

  return `${items.slice(0, itemsToShow).join(', ')} and ${
    itemsLength - itemsToShow
  } more`;
};

export default eclipseItems;
